<template>
    <v-flex xs12 class="mt-5">
        <canvas id="delivery" height="400" style="width: 100%"></canvas>
    </v-flex>
</template>

<script>
    export default {
        name: 'orderDelivery',
        props: ['dataDelivery'],
        mounted () {
            let ctx = document.getElementById('delivery').getContext('2d')

            new Chart(ctx, {
                type: 'bar',
                data: {
                    labels: ['Доставка'],
                    datasets: [
                        {
                            label: 'Самовывоз',
                            data: [this.dataDelivery.delivery_self],
                            backgroundColor: ['#009600'],
                        },
                        {
                            label: 'От заведения',
                            data: [this.dataDelivery.delivery_shipping],
                            backgroundColor: ['#008e94']
                        },
                    ]
                },
                options: {
                    responsive: true,
                    legend: {
                        position: 'bottom',
                    },
                    title: {
                        display: true,
                        text: 'Статистика по способу доставки'
                    }
                }
            })
        }
    }
</script>
